//  actions
import TYPES from './types'

//  initialState
import initialState from './initialState'

// Model
import model from './model'

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.MCLEOD_COMPANIES.FETCH.REQUEST:
      return model.loading(state)
    case TYPES.MCLEOD_COMPANIES.FETCH.SUCCEEDED:
      return model.capturedResponse(state, action.payload)
    case TYPES.MCLEOD_COMPANIES.FETCH.FAILED:
      return model.error(state, action.payload)
    case TYPES.MCLEOD_COMPANIES.CLEAN.ERRORS:
      return model.clean(state)
    case TYPES.MCLEOD_COMPANIES.CLEAN.STATE:
      return model.clean(initialState)
    default:
      return state
  }
}
